import gql from 'graphql-tag';

const CHECKOUT = gql`
  mutation checkoutProducts($userId: ID!) {
    checkoutProducts(userId: $userId)
  }
`;

export default CHECKOUT;